<template>
    <div class="after-sale-reqpair-pc">
        <a-tabs type="card" v-model:activeKey="activeKey">
            <a-tab-pane key="afterSaleRepair" tab="日常报修">
                <after-sale-repair v-if="activeKey === 'afterSaleRepair'"></after-sale-repair>
            </a-tab-pane>
            <a-tab-pane key="repairStatistics" tab="售后问题汇总">
                <repair-statistics v-if="activeKey === 'repairStatistics'"></repair-statistics>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import afterSaleRepair from "@/views/afterSaleRepair/pc/reindex.vue";
import repairStatistics from '@/views/afterSaleRepair/pc/repairStatistics.vue';
import rootCauseAnalysis from '@/views/afterSaleRepair/pc/rootCauseAnalysis/index.vue';

export default defineComponent({
    components: {
        afterSaleRepair,
        repairStatistics,
        rootCauseAnalysis,
    },
    setup(props, context) {
        const activeKey = ref('afterSaleRepair');
        return {
            activeKey
        };
    },
});
</script>

<style lang="less" scoped>
.after-sale-reqpair-pc {
    background: #fff;
    box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04);
    padding: 20px;
    border-radius: 10px;
    height: calc(100vh - 120px);
}
</style>
